import React from 'react';
import styled from 'styled-components';
import LikeHeart from 'web-ui-kit/assets/LikeHeart';
import { primaryM } from 'web-ui-kit/colors';
import { MQ_FOR_TABLET_LANDSCAPE_UP } from 'web-ui-kit/media';
import { Header5LargeStyles, BodySmallStyles, BodyLargeStyles, fontWeightSemiBold } from 'web-ui-kit/typography';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

var LEARN_MORE_URL = 'https://modsy.zendesk.com/hc/en-us/articles/360050687491-Why-can-t-I-swap-an-item-into-my-Modsy-designs';
/**
 * UI for the 2-D only info message.
 */

function TwoDOnly() {
  var Container = styles.Container,
      ExternalLink = styles.ExternalLink,
      Heading = styles.Heading,
      Heart = styles.Heart,
      Paragraph = styles.Paragraph;
  return (
    /*#__PURE__*/
    React.createElement(Container, {
      "data-testid": '2d-only'
    },
    /*#__PURE__*/
    React.createElement(Heading, null, copy.heading),
    /*#__PURE__*/
    React.createElement(Paragraph, null, copy.paragraph.preIcon,
    /*#__PURE__*/
    React.createElement("span", null,
    /*#__PURE__*/
    React.createElement(Heart, null)), copy.paragraph.postIcon,
    /*#__PURE__*/
    React.createElement(ExternalLink, {
      href: LEARN_MORE_URL,
      target: "_blank",
      rel: "noopener noreferrer"
    }, copy.linkText)))
  );
}

var copy = {
  heading: 'Want to see this item in your designs?',
  linkText: 'Learn more',
  paragraph: {
    preIcon: 'This item is currently not in the Modsy 3D Catalog. Tap the',
    postIcon: 'to show us you’re interested and we’ll let you know if it becomes available in the future. '
  }
};
var styles = {
  Container: styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n\n    padding: 1.5rem 1rem;\n\n    ", " {\n      padding: 1.5rem 0;\n    }\n  "])), MQ_FOR_TABLET_LANDSCAPE_UP),
  Heading: styled.p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    margin-bottom: 0.25rem;\n  "])), Header5LargeStyles),
  Paragraph: styled.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n\n    ", " {\n      ", ";\n    }\n  "])), BodySmallStyles, MQ_FOR_TABLET_LANDSCAPE_UP, BodyLargeStyles),
  Heart: styled(LikeHeart)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    margin: 0 0.5rem;\n    transform: translateY(3px);\n  "]))),
  ExternalLink: styled.a(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    color: ", ";\n    font-weight: ", ";\n    text-decoration: none;\n    &:hover {\n      text-decoration: underline;\n    }\n  "])), primaryM, fontWeightSemiBold)
};
export default TwoDOnly;